import { PortableText } from "@portabletext/react";
import { UnderlineLink } from "../../hooks/usePortableTextComponents";

const InfoText = (props) => {

    const {       
        content
    } = props;

  return (
    <div className="info__text-wrapper">
        <PortableText value={content} components={UnderlineLink} />
    </div>
  )
}

export default InfoText